import React from "react";
import missionbg from '../image/mission.png'
import globe from '../image/globe.png'
import Navigation from "./Navbar";
import Footer from "./Footer";
const AboutUsGdPhD = () => {
  return (
   <div>

   <div className="fixed top-0 left-0 w-full bg-white shadow-md z-50">
    <Navigation/>
   </div>

    <div className="text-blue-900 lg:pt-[150px] pt-[114px] bg-gradient-to-b from-white to-blue-50">
      {/* Header */}
   <section className="bg-white text-center py-16 px-6">
  <h1 className="text-4xl md:text-4xl font-bold tracking-wide text-blue-900">
    ABOUT <span className="text-orange-600">US</span>
  </h1>

  <p className="max-w-5xl mx-auto mt-8 text-lg leading-relaxed text-blue-900">
    We resolve to initiate the{" "}
    <span className="font-semibold text-blue-900">
      Global Diaspora of Public Health Dialogues (G<sup>d</sup>PhD)
    </span>
    , focused on synergizing global public health excellence towards fostering a{" "}
    <span className="font-medium text-orange-600">
      healthy global community
    </span>{" "}
    through a{" "}
    <span className="italic text-blue-900">
      collaborative and coordinated approach
    </span>{" "}
    for equitable resource allocation and optimization.
  </p>
</section>


      {/* Vision & Mission */}
     <section
  className="bg-cover bg-center py-20">
  {/* style={{ backgroundImage: `url(${missionbg})` }} */} 
   

  <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-16">

    {/* VISION */}
    <div>

      {/* Title */}
       
        
  <h2 className="text-5xl font-bold text-orange-600 py-[10px] px-8 relative">
  {/* Top curved line */}
  <div className="absolute top-0 left-0 w-full">
    <div className="h-[4px] w-2/3 mx-auto bg-gradient-to-r from-transparent via-blue-900 to-transparent rounded-b-full"></div>
  </div>
  
  <div className="flex items-center justify-center gap-[2px">
    {/* Globe with Indian flag */}
    <div className="relative">
      <span className="text-4xl">🌍</span>
    </div>
    <span>Vision</span>
  </div>
  
  {/* Bottom curved line */}
  <div className="absolute bottom-0 left-0 w-full">
    <div className="h-[4px] w-2/3 mx-auto bg-gradient-to-r from-transparent via-orange-600 to-transparent rounded-t-full"></div>
  </div>
</h2>
<img src={globe} className="mx-auto pt-2 w-[200px]"></img>
     <p className="text-center italic"><span className="font-bold text-blue-900">To establish Global Collaborative <br/>Leadership of Indian Healthcare </span>in coordination with <br/>global healthcare systems by<span className="font-bold text-blue-900">2030.</span></p>
    </div>

   <div>
  {/* Mission Header with curved borders */}
  <h2 className="text-5xl font-bold text-orange-600 py-[10px] px-8 relative mb-4">
    {/* Top curved line */}
    <div className="absolute top-0 left-0 w-full">
      <div className="h-[4px] w-2/3 mx-auto bg-gradient-to-r from-transparent via-blue-900 to-transparent rounded-b-full"></div>
    </div>
    
    <div className="flex items-center justify-center gap-2">
      {/* Target icon */}
      <div className="relative">
        <span className="text-4xl">🎯</span>
      </div>
      <span>Mission</span>
    </div>
    
    {/* Bottom curved line */}
    <div className="absolute bottom-0 left-0 w-full">
      <div className="h-[4px] w-2/3 mx-auto bg-gradient-to-r from-transparent via-orange-600 to-transparent rounded-t-full"></div>
    </div>
  </h2>

  {/* Mission statement */}
  <div className="text-center mb-6">
    <p className="text-lg font-semibold text-blue-900">
      GdPhD shall commit to-
    </p>
  </div>

  {/* Mission points */}
  <div className="max-w-3xl mx-auto">
    <ul className="space-y-4 text-lg text-blue-900">
      <li className="flex gap-3 items-start">
        <span className="text-orange-600 font-bold text-2xl mt-1">•</span>
        <span>Promoting Track-II Health Diplomacy and Global Collaborative Outreach</span>
      </li>
      <li className="flex gap-3 items-start">
        <span className="text-orange-600 font-bold text-2xl mt-1">•</span>
        <span>Mapping future Health Imperatives in the wake of rising GBD and Health Emergencies</span>
      </li>
      <li className="flex gap-3 items-start">
        <span className="text-orange-600 font-bold text-2xl mt-1">•</span>
        <span>Leveraging and sharing the great experiences and excellence of <span className="font-bold">Indian Healthcare Stack </span></span>
      </li>
      <li className="flex gap-3 items-start">
        <span className="text-orange-600 font-bold text-2xl mt-1">•</span>
        <span>Enabling Assured and Secured Last Mile Accessible, and Affordable Supply Chains</span>
      </li>
    </ul>
  </div>
</div>

  </div>
</section>

{/* Our Initiatives Section */}
<section className="py-16">
  <div className="max-w-5xl mx-auto px-6">
    {/* Header with ------*------ decoration */}
    <div className="flex items-center justify-center mb-12">
      <div className="h-[2px] w-32 bg-gradient-to-r from-transparent to-blue-900"></div>
      <div className="relative px-8">
        <h2 className="text-4xl font-bold text-center">
          
          <span className="text-orange-600"> Inception</span>
        </h2>
        
      </div>
      <div className="h-[2px] w-32 bg-gradient-to-l from-transparent to-blue-900"></div>
    </div>

    {/* Content */}
    <div className="space-y-6 text-lg text-gray-800">
      <p className="text-center leading-relaxed">
        <span className="font-semibold text-blue-900">G<sup>d</sup>PhD</span> has been conceptualized in the backdrop of our two initiatives: 
        Launch of <span className="font-bold text-orange-600">"Global South Healthcare Journal"</span> in January 2025, 
        and successfully organized <span className="font-bold text-blue-900">India Inc.'s First Ever VUCA Conference</span> in June 2025 
        in collaboration with the country's oldest industry association 
        <span className="font-bold text-blue-900"> PHD Chamber of Commerce and Industry</span>.
      </p>
      
      <p className="text-center leading-relaxed">
        <span className="font-semibold text-blue-900">G<sup>d</sup>PhD</span> aims at leveraging global healthcare expertise, strengthening collaborative networks, 
        promoting resource optimization, knowledge exchange, and innovations towards building 
        <span className="font-bold text-orange-600"> robust and resilient global health systems</span>.
      </p>
    </div>
  </div>
</section>
    </div>
        <main
        className="relative z-10"  
        
      >
        <Footer />
      </main>
     </div>
  );
};

export default AboutUsGdPhD;
